const CLOUD = process.env.NEXT_PUBLIC_CLOUDINARY_CLOUD_NAME;

// Poster from the 1s frame (works for you already)
export function cldPosterUrl(publicId, second = 1) {
  return `https://res.cloudinary.com/${CLOUD}/video/upload/so_${second}/${publicId}.jpg`;
}

// Progressive WebM (VP9), optimized
export function cldVideoWebm(publicId) {
  // no f_auto; let’s be explicit for video
  return `https://res.cloudinary.com/${CLOUD}/video/upload/q_auto:good,vc_vp9,br_auto/${publicId}.webm`;
}

// Progressive MP4 (H.264), optimized — safest default
export function cldVideoMp4(publicId) {
  return `https://res.cloudinary.com/${CLOUD}/video/upload/q_auto:good,vc_h264,br_auto/${publicId}.mp4`;
}

// Plain MP4 (no transforms) as a last-resort fallback
export function cldVideoPlainMp4(publicId) {
  return `https://res.cloudinary.com/${CLOUD}/video/upload/${publicId}.mp4`;
}
